import { RemindersEditorReminderUnitValue } from '@surglogs-app/network'

import { RemindersEditorReminderValue } from '../types'

export const REMINDERS_EDITOR_OPTION_CUSTOM = 'CUSTOM' as const

export enum RemindersEditorDefaultOption {
  ONE_WEEK = 'ONE_WEEK',
  ONE_MONTH = 'ONE_MONTH',
  SIX_MONTHS = 'SIX_MONTHS',
  ONE_YEAR = 'ONE_YEAR',
}

export const RemindersEditorDefaultOptions: Record<
  RemindersEditorDefaultOption,
  RemindersEditorReminderValue
> = {
  ONE_WEEK: {
    amount: 1,
    unit: RemindersEditorReminderUnitValue.WEEKS,
  },
  ONE_MONTH: {
    amount: 1,
    unit: RemindersEditorReminderUnitValue.MONTHS,
  },
  SIX_MONTHS: {
    amount: 6,
    unit: RemindersEditorReminderUnitValue.MONTHS,
  },
  ONE_YEAR: {
    amount: 1,
    unit: RemindersEditorReminderUnitValue.YEARS,
  },
}

export const RemindersEditorDefaultSelectedOptions = [
  RemindersEditorDefaultOptions.ONE_WEEK,
  RemindersEditorDefaultOptions.ONE_MONTH,
]

export const ReminderUnitDaysMap = {
  [RemindersEditorReminderUnitValue.DAYS]: 1,
  [RemindersEditorReminderUnitValue.WEEKS]: 7,
  [RemindersEditorReminderUnitValue.MONTHS]: 30,
  [RemindersEditorReminderUnitValue.YEARS]: 365,
}

export const ReminderUnitsMap = {
  [RemindersEditorReminderUnitValue.DAYS]: 'day',
  [RemindersEditorReminderUnitValue.WEEKS]: 'week',
  [RemindersEditorReminderUnitValue.MONTHS]: 'month',
  [RemindersEditorReminderUnitValue.YEARS]: 'year',
} as const
